import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import ErrorBoundary from './components/ErrorBoundary.tsx';
import './index.css';

console.log('Heitje App: Initializing...');
console.log('Environment check:', {
  hasSupabaseUrl: !!import.meta.env.VITE_SUPABASE_URL,
  hasSupabaseKey: !!import.meta.env.VITE_SUPABASE_ANON_KEY,
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  mode: import.meta.env.MODE,
  dev: import.meta.env.DEV,
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Root element not found in DOM');
  document.body.innerHTML = '<div style="padding: 40px; text-align: center; font-family: system-ui;"><h1 style="color: #dc2626;">Root element not found</h1><p>The application could not initialize properly.</p><p style="font-size: 14px; color: #666;">Check the browser console for more details.</p></div>';
  throw new Error('Root element not found');
}

try {
  console.log('Creating React root...');
  const root = createRoot(rootElement);

  console.log('Rendering app...');
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>
  );
  console.log('Heitje App: Mounted successfully');
} catch (error) {
  console.error('Failed to mount app:', error);
  if (error instanceof Error) {
    console.error('Error message:', error.message);
    console.error('Error stack:', error.stack);
  }
  document.body.innerHTML = `
    <div style="padding: 40px; max-width: 600px; margin: 0 auto; font-family: system-ui;">
      <h1 style="color: #dc2626; margin-bottom: 16px;">Er is een fout opgetreden</h1>
      <p style="margin-bottom: 24px; color: #374151;">De applicatie kon niet worden geladen. Probeer de pagina te vernieuwen.</p>
      <button onclick="window.location.reload()" style="background: #059669; color: white; padding: 12px 24px; border: none; border-radius: 8px; font-size: 16px; cursor: pointer;">
        Pagina vernieuwen
      </button>
      <details style="margin-top: 24px; padding: 16px; background: #f3f4f6; border-radius: 8px;">
        <summary style="cursor: pointer; font-weight: 600; margin-bottom: 8px;">Technische details</summary>
        <pre style="font-size: 12px; overflow: auto; color: #1f2937;">${error instanceof Error ? error.message : String(error)}</pre>
      </details>
    </div>
  `;
}
